export const WORKFLOW_STATUS_CHANGED = 'at/entities/tasks/WORKFLOW_STATUS_CHANGED'


// WEBPACK FOOTER //
// ./web/js/entities/tasks/actionTypes.js